import { render, staticRenderFns } from "./lkuBenefit.vue?vue&type=template&id=1664a1bf"
import script from "./lkuBenefit.vue?vue&type=script&lang=js"
export * from "./lkuBenefit.vue?vue&type=script&lang=js"
import style0 from "./lkuBenefit.vue?vue&type=style&index=0&id=1664a1bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports